import React, { useState } from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { SizeProp } from "@fortawesome/fontawesome-svg-core";
import { faClipboard } from "@fortawesome/free-solid-svg-icons";

import { OverlayTrigger, Tooltip } from "react-bootstrap";

import "./styles.css";

interface ICopyToClipboardProps {
    children: string;
    size?: SizeProp;
    className?: string;
}

export default function CopyToClipboard(props: ICopyToClipboardProps) {
    const [showTootip, setShowTootip] = useState(false);

    return (
        <>
            {props.children && props.children.length > 0 && (
                <OverlayTrigger
                    show={showTootip}
                    overlay={
                        <Tooltip
                            id="tooltip-copy-to-clipboard"
                            show={showTootip}
                        >
                            Copiado!
                        </Tooltip>
                    }
                >
                    <span className={props.className}>
                        <FontAwesomeIcon
                            icon={faClipboard}
                            size={props.size}
                            className="clip-copy"
                            onClick={() => {
                                navigator.clipboard.writeText(props.children);
                                setShowTootip(true);
                            }}
                            onMouseLeave={() => {
                                setTimeout(() => setShowTootip(false), 500);
                            }}
                        />
                    </span>
                </OverlayTrigger>
            )}
        </>
    );
}
